/**
 * @generated SignedSource<<b4310f301c256ea95275f5723888b05a>>
 * @relayHash dea9c3cbfe29b9c92cdeb224b8f076c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7

import type { ConcreteRequest } from 'relay-runtime';
export type useNudgeContributorFilterQuery$variables = {
  contentId: string;
};
export type useNudgeContributorFilterQuery$data = {
  readonly contentContributors: {
    readonly isCurrentUserContributor: boolean | null;
  } | null;
};
export type useNudgeContributorFilterQuery = {
  response: useNudgeContributorFilterQuery$data;
  variables: useNudgeContributorFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentContributors",
    "kind": "LinkedField",
    "name": "contentContributors",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useNudgeContributorFilterQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNudgeContributorFilterQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dea9c3cbfe29b9c92cdeb224b8f076c7",
    "id": "3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7",
    "metadata": {},
    "name": "useNudgeContributorFilterQuery",
    "operationKind": "query",
    "text": "query useNudgeContributorFilterQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
  }
};
})();

(node as any).hash = "427fb0db9de3e615035eab567b67ccf0";

export default node;
